export type TranslationsVersionLine = {
  major: number;
  minor: number;
};

/** CDN translation line baked from `translations-version.json` at build time. */
export const translationsVersionLine: TranslationsVersionLine = {
  major: __TRANSLATIONS_VERSION_MAJOR__,
  minor: __TRANSLATIONS_VERSION_MINOR__,
};

/** Semver line prefix for CDN paths, e.g. `1.0`. */
export function formatTranslationsVersionLine(
  version: TranslationsVersionLine = translationsVersionLine
): string {
  return `${version.major}.${version.minor}`;
}
